import React__default, { useState, useEffect } from 'react';
import { MasonryViewSize, SpecificDataviewType } from '@keepeek/commons';
import { ClickAwayListener, Popper, Paper, Typography, ToggleButtonGroup, ToggleButton, Slider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import KButtonAction from '../../KButtons/KButtonAction/index.js';
import { useFontAwesomeIconSize } from '../../lib/fontawesome/index.js';

var ModeSwitcher = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.display, display = _b === void 0 ? [] : _b, masonryViewSize = _a.masonryViewSize, setMasonryViewSize = _a.setMasonryViewSize, iconMosaic = _a.iconMosaic, iconList = _a.iconList, iconMasonry = _a.iconMasonry, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    var fontAwesomeIconSize = useFontAwesomeIconSize();
    var t = useTranslation("refront-components").t;
    var _d = useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var handleClick = function (event) {
        return setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    // close the popper when the user scroll
    useEffect(function () {
        var scrollFunction = function () { return setAnchorEl(null); };
        window.addEventListener("scroll", scrollFunction);
        return function () { return window.removeEventListener("scroll", scrollFunction); };
    }, []);
    var sliderValue;
    switch (masonryViewSize) {
        case MasonryViewSize.Small:
            sliderValue = 0;
            break;
        case MasonryViewSize.Medium:
            sliderValue = 5;
            break;
        case MasonryViewSize.Large:
            sliderValue = 10;
            break;
        default:
            sliderValue = 0;
    }
    var open = !!anchorEl;
    if ((display === null || display === void 0 ? void 0 : display.length) > 1) {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(KButtonAction, { onClick: handleClick, title: t("components.mode-switcher.view-type"), "aria-label": t("components.mode-switcher.view-type"), sx: {
                    color: function (theme) { return theme.palette.text.primary; }
                } },
                value === SpecificDataviewType.LIST && (React__default.createElement(KIcon, { className: "fa-regular fa-table-list ".concat(fontAwesomeIconSize) })),
                value === SpecificDataviewType.MOSAIC && (React__default.createElement(KIcon, { className: "fa-solid fa-grid-horizontal ".concat(fontAwesomeIconSize) })),
                value === SpecificDataviewType.MASONRY && (React__default.createElement(KIcon, { className: "fa-solid fa-objects-column ".concat(fontAwesomeIconSize) })),
                !open && (React__default.createElement(KIcon, { sx: {
                        paddingLeft: function (theme) { return theme.spacing(1); },
                        paddingTop: "2px"
                    }, className: "fa-solid fa-caret-down fa-xs" })),
                open && (React__default.createElement(KIcon, { sx: {
                        paddingLeft: function (theme) { return theme.spacing(1); },
                        paddingTop: "2px"
                    }, className: "fa-solid fa-caret-up fa-xs" }))),
            open && (React__default.createElement(ClickAwayListener, { onClickAway: function () { return setAnchorEl(null); } },
                React__default.createElement(Popper, { disablePortal: true, open: true, anchorEl: anchorEl, style: {
                        zIndex: 10
                    }, role: "dialog", "aria-modal": true },
                    React__default.createElement(Paper, { elevation: 4, sx: {
                            padding: 2,
                            margin: 1
                        } },
                        React__default.createElement(Typography, { sx: { fontSize: "14px", color: function (theme) { return theme.palette.grey[600]; } } }, t("components.mode-switcher.view-type")),
                        React__default.createElement(ToggleButtonGroup, { value: value, exclusive: true, onChange: function (_, newValue) { return newValue && onChange(newValue); }, "aria-label": t("components.mode-switcher.dataview-mode.label"), size: "small", sx: { marginTop: "4px", marginBottom: "8px" } },
                            display && display.includes(SpecificDataviewType.MOSAIC) && (React__default.createElement(ToggleButton, { size: "small", value: "mosaic", "aria-label": t("components.mode-switcher.mosaic-view.label"), title: t("components.mode-switcher.mosaic-view.label"), sx: { width: "36px", height: "36px" } }, iconMosaic || React__default.createElement(KIcon, { className: "fa-solid fa-grid-horizontal fa-lg" }))),
                            display && display.includes(SpecificDataviewType.LIST) && (React__default.createElement(ToggleButton, { size: "small", value: "list", "aria-label": t("components.mode-switcher.list-view.label"), title: t("components.mode-switcher.list-view.label"), sx: { width: "36px", height: "36px" } }, iconList || React__default.createElement(KIcon, { className: "fa-regular fa-table-list fa-lg" }))),
                            display && display.includes(SpecificDataviewType.MASONRY) && (React__default.createElement(ToggleButton, { size: "small", value: "masonry", "aria-label": t("components.mode-switcher.masonry-view.label"), title: t("components.mode-switcher.masonry-view.label"), sx: { width: "36px", height: "36px" } }, iconMasonry || React__default.createElement(KIcon, { className: "fa-solid fa-objects-column fa-lg" })))),
                        value === "masonry" && (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(Typography, { sx: { fontSize: "14px", color: function (theme) { return theme.palette.grey[600]; } } }, t("components.mode-switcher.display-size")),
                            React__default.createElement(Slider, { "aria-label": t("components.mode-switcher.display-size.description"), size: "small", defaultValue: 0, min: 0, max: 10, step: 5, value: sliderValue, marks: true, track: false, onChange: function (_, newValue) {
                                    if (newValue === 0) {
                                        setMasonryViewSize(MasonryViewSize.Small);
                                    }
                                    else if (newValue === 5) {
                                        setMasonryViewSize(MasonryViewSize.Medium);
                                    }
                                    else {
                                        setMasonryViewSize(MasonryViewSize.Large);
                                    }
                                }, valueLabelDisplay: "off" })))))))));
    }
    return null;
};

export { ModeSwitcher as default };
//# sourceMappingURL=index.js.map
